import { booleanAttribute, Component, computed, input, model, signal } from '@angular/core';

import { FormButtonsModule, inputProviders } from '@re-core/ngx-ui';
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerInputEvent,
  MatDatepickerToggle,
} from '@angular/material/datepicker';
import { generateId } from '@lc/util';
import { AbstractControl, ControlValueAccessor, ValidationErrors, Validator } from '@angular/forms';
import { provideNativeDateAdapter } from '@angular/material/core';
import { BspkFormField } from '../form-field';
import { noop, TextInputSize } from '../util';
import { ControlValidator } from '../util/control-validator';

@Component({
  selector: 'bspk-datepicker',
  imports: [
    FormButtonsModule,
    BspkFormField,
    MatDatepicker,
    MatDatepickerToggle,
    MatDatepickerInput,
  ],
  templateUrl: './datepicker-field.component.html',
  styleUrl: './datepicker-field.component.scss',
  providers: [...inputProviders(BspkDatepickerField), provideNativeDateAdapter()],
})
export class BspkDatepickerField
  extends ControlValidator
  implements ControlValueAccessor, Validator {
  readonly value = model<Date | null>(null);
  readonly disabled = model(false);
  readonly readOnly = input(false, { transform: booleanAttribute });
  readonly label = input.required<string>();
  readonly required = input(false, { transform: booleanAttribute });
  readonly min = input<Date | null>(null);
  readonly max = input<Date | null>(null);
  readonly helperText = input<string>();
  readonly controlId = input(generateId('datepicker'));
  readonly size = input<TextInputSize>('medium');
  readonly labelId = computed(() => `${this.controlId()}-label`);

  private _onChange: (value: Date) => void = noop;
  private _onTouched = noop;

  handleBlur(_event: Event) {
    this._onTouched();
  }

  handleChange(event: MatDatepickerInputEvent<any>): void {
    if (this.disabled() || this.readOnly()) return;
    this.value.set(event.value);
    this._onChange(event.value);
  }

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled.set(isDisabled);
  }

  writeValue(obj: any): void {
    this.value.set(obj);
  }

  registerOnValidatorChange(_fn: VoidFunction) {
    // noop
  }

  validate(_control: AbstractControl<Date>): ValidationErrors | null {
    return null;
  }
}
